import './CoralStatCards.scss'

import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { CoralMasterCardVisuals } from '@websrc/DataMappers/mapCoralMasterCard'
import { mapCoralWebStatCards } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import { CoralMasterCard } from '../../../coral-library/cards/Coral/ContentCard/CoralMasterCard'

type CoralStatCardsProps = ReturnType<typeof mapCoralWebStatCards>

export const CoralStatCards: FC<CoralStatCardsProps> = (props) => {
  const visuals: CoralMasterCardVisuals = {
    subheadSize: 'body-md',
    headlineSize: 'h2-md',
    bodySize: 'body-sm',
    contentContainerColor: 'off-white',
    contentPadding: '3xl',
    imageOrientation: 'bottom',
    paddingBody: 'lg',
    radius: 4,
  }

  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-stat-cards'}>
        <CoralHeading header={'Benefits of hands-on learning'} />
        <div className={'coral-stat-cards__container'}>
          <CoralCardsSlider
            belowSliderContent={
              <div className={'coral-stat-cards__source-container'}>
                {props.sourceLinks?.length > 0 && (
                  <div className={'coral-stat-cards__source'}>
                    <span>
                      {props.source}{' '}
                      {props.sourceLinks.map((link, idx) => (
                        <React.Fragment key={idx}>
                          <a
                            className={'coral-stat-cards__source-link'}
                            href={link.url}
                            rel={'noopener noreferrer'}
                            target={'_blank'}
                          >
                            {link.name}
                          </a>
                          {idx < props.sourceLinks.length - 1 && ', '}
                        </React.Fragment>
                      ))}
                    </span>
                  </div>
                )}
              </div>
            }
            forceRow={true}
          >
            {props.cards.map((card, index) => (
              <CoralMasterCard key={index} {...card} visuals={visuals} />
            ))}
          </CoralCardsSlider>
        </div>
      </div>
    </div>
  )
}
